import MobileAutoSelectPriceChart from './MobileAutoSelectPriceChart';

export default MobileAutoSelectPriceChart;
